const APPLICATION_URL = process.env.REACT_APP_API_URL_NODE;

export const endpoint = {
  // Api Base Url

  // For Local Environmet
  // API_BASE_URL: "http://localhost:8080/api",

  // For Devolopment Environmet
  // APPLICATION_URL:
  //   process.env.NODE_ENV === "development"
  //     ? process.env.REACT_APP_API_URL_NODE
  //     : process.env.REACT_APP_NODE_ENV === "staging"
  //     ? process.env.REACT_APP_API_URL_NODE
  //     : process.env.REACT_APP_NODE_ENV === "prod"
  //     ? process.env.REACT_APP_API_URL_NODE
  //     : process.env.REACT_APP_API_URL_NODE,

  // API_BASE_URL: "http://localhost:8080/api/V1",

  API_BASE_URL: APPLICATION_URL,

  LOGIN: "/auth/login",

  GET_MODELS: "/model/get",
  GET_MODEL: "/model/getDetail",
  GET_MODEL_BY_ID: "/model/getById",
  GET_PRODUCTS: "/product/get",
  GET_PRODUCT_BY_ID: "/product/getById/",
  GET_VARIANT_BY_ID: "/product/getVariantById/",
  GET_PUSH_SUMMARY: "/product/validProductSummary",
  DELETE_PRODUCTS: "/product/clearProducts",
  DELETE_MODEL: "/model/delete/",
  BULK_PRODUCTS: "/product/bulkUpload",
  UPDATE_STATUS: "/product/patchProductImage/",
  UPDATE_PRODUCT: "/product/update/",
  UPLOAD_IMAGES: "/product/uploadImages",
  GET_FORMDATA: "/model/getFormData",
  CREATE_MODEL: "/model/create",
  UPDATE_MODEL: "/model/update",
  GET_CORDINATES: "/model/inspectImage",
  GET_TEMP_IMAGES: "/product/getTempImage",
  UPDATE_TEMP_IMAGES: "/product/processImage",
  PREVIEW_IMAGE: "/product/getPreview",
  PATCH_PREVIEW_IMAGE: "/product/patchPreviewImage",
  GET_STORES: "/store/get",
  GET_STOREFORMDATA: "/store/getFormData",
  CREATE_STORE: "/store/create",
  UPDATE_STORE_STATUS: "/store/update",
  SYNC_STORE: "/store/sync",
  GET_MISSING_PRODUCTS: "/product/getMissingBodyType",
  PATCH_MISSING_PRODUCTS: "/product/patchProductBodyType",
  FETCH_STORE_DATA: "store/getStoreData",
  PUSH_PRODUCTS: "/product/pushImages",
  PUSH_MODELS: "/model/pushModels",
  DELETE_IMAGE: "/product/deleteImage",
  GET_EAR_COORD: "/ear",
  GET_NECK_COORD: "/neck",
  GET_WRIST_COORD: "/wrist",
  GET_FINGER_COORD: "/fingers",
};
